module.exports = __webpack_public_path__ + "img/img-7.d20c509b.png";